/**
 * M² Coin Logo mapping — one coin per agent color, with light/dark variant.
 * Used as the assistant avatar in chat messages (replaces the generic brand icon).
 *
 * Light theme (white background) → the DARKER coin stands out best
 * Dark theme  (dark background)  → the BRIGHTER coin stands out best
 */

import blueBright from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Blue/Coin Logo-Blue.png';
import blueDeep from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Blue/Coin Logo-Dark Blue.png';
import greenBright from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Green/Coin Logo-Green.png';
import greenDeep from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Green/Coin Logo-Dark Green.png';
import redBright from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Red/Coin Logo-Red.png';
import redDeep from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Red/Coin Logo-Dark Red.png';
import yellowBright from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Yellow/Coin Logo-Yellow.png';
import yellowDeep from '@/brand-assets/m2/Logo icons/Coin Logo/M² Coin Logo Color/Yellow/Coin Logo-Dark Yellow.png';

import type { TextureColor } from './textures';

const coins = {
  light: {
    blue: blueDeep,
    green: greenDeep,
    red: redDeep,
    yellow: yellowDeep,
  },
  dark: {
    blue: blueBright,
    green: greenBright,
    red: redBright,
    yellow: yellowBright,
  },
} as const;

/**
 * Get the coin logo for an agent based on its chosen color + current theme.
 * Falls back to blue if color is missing.
 */
export function getAgentCoin(color: TextureColor | null | undefined, isDark: boolean): string {
  const mode = isDark ? 'dark' : 'light';
  const key = (color ?? 'blue') as TextureColor;
  return coins[mode][key];
}

/**
 * Solid M² brand hex color for an agent color (used for non-textured surfaces
 * like conversation-list circles).
 */
export const SOLID_AGENT_COLORS: Record<TextureColor, string> = {
  blue: '#6CC7EF',
  green: '#C4D600',
  red: '#D50032',
  yellow: '#FAB600',
};
